import { ReactNode } from "react"
import { Table as Tab } from "flowbite-react"
import cn from "classnames"

interface ITableCell {
  children: ReactNode
  mainCol?: boolean
  className?: string
  [key: string]: any
}

const TableCell = ({ children, mainCol, className, ...props }: ITableCell) => {
  return (
    <Tab.Cell
      {...props}
      className={cn(
        "whitespace-nowrap border-l-2 font-medium text-[14px]",
        {
          "bg-[#EFEFEF]": Boolean(mainCol),
        },
        className,
      )}
    >
      {children}
    </Tab.Cell>
  )
}

export default TableCell
